import { ITask } from '@modules/TasksModule/types';
import { InboxContext } from '../types';
import { inboxActions } from '../state';
import SoftPhoneModule from '@modules/SoftPhoneModule';
import { setInternalCallToAccepted } from '../callHandlers/internalCalls';

function handleTaskAccept(_context: InboxContext, task: ITask): void {
  inboxActions.setSelectedTaskId(task.id);

  if (task.isInternal) {
    setInternalCallToAccepted(_context, task.id);
  }
  SoftPhoneModule.callControl.answer(task.attributes.callId);
}

export default handleTaskAccept;
